module.exports = __webpack_public_path__ + "img/bee_white.6433f194.svg";